import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AccordionSection extends Component {
  static propTypes = {
    children: PropTypes.instanceOf(Object).isRequired,
    isOpen: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  onClick = () => {
    this.props.onClick(this.props.label);
  };

  render() {
    const {
      onClick,
      props: { isOpen, label },
    } = this;

    return (
      <div
        className={`accordion-section ${isOpen ? 'open' : ''}`}
      >
        <h3 className='p-20' onClick={onClick} style={{ cursor: 'pointer' }}>
          {label}
          <i className="plus-minus"></i>
        </h3>
        {isOpen && (
          <div className='ph-20 pb-20'>
            {this.props.children}
          </div>
        )}
      </div>
    );
  }
}

export default AccordionSection;